export default "__VITE_ASSET__DvxO7jSg__"